import React from "react";

export default ({ children }) => (
    <footer css={{
        padding: "50px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "grey",
        fontSize: ".9em",
    }}>
        { children }
    </footer>
);
